import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

class Spider extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                polar: true,
                type: 'line',
                width: 640,
                height: 565,
                marginRight: 100,
                marginLeft: 100,
            },
            xAxis: {
                labels: {
                    style: {
                        color: 'black',
                        fontSize: '7pt'
                    },
                    distance: 15,
                },
                lineWidth: 0,
                tickmarkPlacement: 'on'
            },
            yAxis: {
                labels: {
                    style: {
                        color: 'black',
                        fontSize: '9pt'
                    }
                },
                min: 0,
                max: 100,
                tickInterval: 10,
                lineWidth: 0,
                gridLineInterpolation: 'polygon',
                showLastLabel: true
            },
            plotOptions: {
                line: {
                    pointPlacement: 'on'
                }
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {registerPlugin(Spider)}
